import $ from 'jquery';
import { dependency } from '../../utils/request';

/**
 * The CDN directory of the Parsley library.
 *
 * @see http://parsleyjs.org/
 * @type {string}
 */
const parsleyDir = 'https://cdnjs.cloudflare.com/ajax/libs/parsley.js/2.7.2/';

function setFormEnabled($form, enabled) {
    $form.find('input, select, textarea').prop('readonly', !enabled);
    $form.find('button').prop('disabled', !enabled);
}

/**
 * Enhances forms with live validation.
 *
 * @param context
 */
export default function validatorDirective(context=document.body) {
    const $context = $(context);
    const $forms = $context.find('form[sw-validator]');

    // Only load Parsley if there are forms on the page
    if ($forms.length > 0) {
        dependency(parsleyDir + 'parsley.min.js', () => window.Parsley).then(function() {
            $forms.each(function() {
                const $form = $(this);
                const parsley = $form.parsley();

                parsley.on('field:validated', function({ $element }) {
                    // Make sure errors reported by the server get removed
                    $element.siblings('.float-label_errors').remove();
                });

                parsley.on('form:submit', ({ $element }) => {
                    $element.addClass('is-posting');
                    setFormEnabled($element, false);

                    const target = $element.prop('target');
                    const $iframe = target ? $(`iframe[name="${target}"]`) : $();

                    $iframe.one('load', (e) => {
                        $element.removeClass('is-posting');
                        setFormEnabled($element, true);
                    });
                });
            });
        });
    }
}



// WEBPACK FOOTER //
// ./source/scripts/directives/form/validator.js